/*
 * @Author: Fan
 * @Date: 2020-04-13 15:36:59
 * @LastEditTime: 2020-07-06 18:15:24
 * @LastEditors: zhuqiu
 * @Description: 控件拥有的属性和属性的值类型和在设计端属性栏名称. 属性独特的行为是在 conduct文件配置.
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\RelevanceForm\schema.ts
 */
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
/**
 * 属性根据类型有要一下几种输入框:
 * string默认显示为input:text
 * string format:date、date-time、time默认显示为input:date
 * string format:binary默认显示为input:file
 * boolean默认显示为select
 * integer默认显示为无小数点input:number
 * number默认显示为带小数点input:number
 *
 * 如果需要定制属性的输入框(比如弹框),则应该在conduct文件配置
 */
export default {
    $id: "RelevanceForm",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemName').toString(),
            default: "",
        },
        name_i18n: {
            type: DataType.Object,
            title: i18n.t('dataitem.MultiLanguage').toString(),
        },
        visible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Visible').toString(),
            default: true,
        },
        dataItemName: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemCode').toString(),
        },
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        style: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlStyle').toString(),
        },
        tips: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlTips').toString(),
        },
        searchFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLimit').toString(),
            default: "",
        },
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
        },
        schemaCode: {
            type: DataType.String,
            title: i18n.t('dataitem.BizModal').toString(),
        },
        queryCode: {
            type: DataType.String,
            title: i18n.t('dataitem.QueryList').toString(),
        },
        displayField: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayField').toString(),
        },
        mappings: {
            type: DataType.String,
            title: i18n.t('dataitem.MappingField').toString(),
        },
        conditions: {
            type: DataType.String,
            title: i18n.t('dataitem.QueryConditions').toString(),
        },
        mobileConditions: {
            type: DataType.String,
            title: i18n.t('dataitem.MobileQueryConditions').toString(),
        },
        linkMode: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LinkMode').toString(),
            default: true
        },
        selectMode: {
            type: DataType.String,
            title: i18n.t('dataitem.SelectType').toString(),
            default: 'popup'
        },
        showField: {
            type: DataType.Array,
            title: i18n.t('dataitem.ModelField').toString(),
        },
        isAuthorize: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.TemporaryAuthorization').toString(),
            default: true
        },
        defaultVal: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
        },
        onChange: {
            type: DataType.String,
            title: i18n.t('dataitem.ChangeEvent').toString(),
        },
        requiredFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.RequiredFormula').toString(),
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
        readonlyFormula: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.ReadonlyFormula').toString(),
            default: false,
        },
        isScan: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.InputByScanCode').toString(),
            default: false,
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
